import * as _ from 'lodash';
import { action, observable, runInAction } from 'mobx';
import { DefaultOrganization, IOrganization } from 'src/Definitions';
import { Client, IOrganizationDto, SwaggerResponse } from 'src/generated_client';
import GlobalStore from 'src/stores/GlobalStore';
import DataTableStore from '../DataTableStore';

export default class OrganizationsStore {
    @observable
    public isLoading: boolean = false;
    @observable
    public isModalOpen: boolean;
    @observable
    public organizations: IOrganization[];
    @observable
    public selectedOrganization?: IOrganizationDto;
    public dataTableStore: DataTableStore<IOrganizationDto, IOrganization>;

    constructor(private globalStore: GlobalStore, private client: Client) {}

    @action.bound
    public getAllOrganizations(pageNumber?: number, pageSize?: number) {
        if (!this.globalStore.isAdmin) {
            this.organizations = [
                { ...DefaultOrganization(), ...this.globalStore.currentOrganization },
            ];
            return Promise.resolve();
        } else {
            if (!pageNumber) {
                pageNumber = 1;
            }
            if (!pageSize) {
                pageSize = 25;
            }
            return this.client
                .getAllOrganizations(undefined, pageNumber, pageSize)
                .then((resp: SwaggerResponse<IOrganizationDto[]>) =>
                    runInAction(() => {
                        this.organizations = resp.result.map(this.addDefaultFields);
                    })
                );
        }
    }

    private addDefaultFields = (organization: IOrganizationDto): IOrganization => {
        return { ...DefaultOrganization(), ...organization };
    };
}



// WEBPACK FOOTER //
// ./src/stores/OrganizationsStore/OrganizationsStore.ts